<template>
   <div class="page bg-gray pb-fixed-btn">
       <backTitleBar></backTitleBar>
       <div class="content" style="height:12rem">
           <div class="card">
               <div class="pd-020">
                   <div class="input-field bd-bot click" @click="showCategoryPop = true;">
                       <div class="fs-32 color-333 left required">主营类目 </div>
                       <div class="field-content" :class="formItem.businessTypeName ? 'color-333':'color-999'">{{formItem.businessTypeName || '请选择主营类目'}}</div>
                       <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                   </div>
                   <div class="input-field">
                       <div class="fs-32 color-333 left required">营业时间</div>
                       <van-field class="input" type="text" :clearable="true" v-model="formItem.businessTime" placeholder="请输入营业时间" />

                   </div>
               </div>
           </div>
           <div class="card mt-20">
               <div class="pd-020">
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">门店名称</div>
                       <van-field @click="inputClick()" class="input" type="text" :clearable="true" v-model="formItem.shopName" placeholder="请输入门店名称" />
                   </div>
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">服务电话</div>
                       <van-field @click="inputClick()" class="input" type="tel" :clearable="true" v-model="formItem.serviceTel" placeholder="请输入服务电话" />
                   </div>
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">负责人</div>
                       <van-field @click="inputClick()" class="input" type="text" :clearable="true" v-model="formItem.linkor" placeholder="请输入负责人" />
                   </div>
                   <div class="input-field bd-bot">
                       <div class="fs-32 color-333 left required">负责人电话</div>
                       <van-field @click="inputClick()" class="input" type="tel" :clearable="true" v-model="formItem.linkTelephone" placeholder="请输入负责人电话" />
                   </div>
                   <!--<div class="input-field bd-bot">-->
                       <!--<div class="fs-32 color-333 left required">负责人身份证号</div>-->
                       <!--<input type="text" class="input" placeholder="请输入负责人身份证号" v-model="formItem.subTitle">-->
                   <!--</div>-->
                   <div class="input-field bd-bot click" @click="$refs.pickerArea.popupShow = true;">
                       <div class="fs-32 color-333 left required">所在地区 </div>
                       <div class="field-content" :class="formItem.areaname ? 'color-333':'color-999'">{{formItem.areaname.split(",").join(" ") || '请选择所在地区'}}</div>
                       <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                   </div>
                   <div class="input-field bd-bot click" @click="$refs.chooseMap.popupShow = true">
                       <div class="fs-32 color-333 left required">经纬度</div>
                       <div class="field-content" :class="formItem.lng && formItem.lat ? 'color-333':'color-999'">{{formItem.lng + ' , ' +  formItem.lat|| '请选择所在经纬度'}}</div>
                       <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                   </div>
                   <div class="input-field" style="align-items: baseline">
                       <div class="fs-32 color-333 left required">详细地址</div>
                       <van-field class="input" type="textarea" autosize :clearable="true" v-model="formItem.address" placeholder="请输入详细地址" />
                   </div>
               </div>
           </div>
       </div>
       <div class="fixed-bot">
           <div class="btn click" @click="submitForm()">保存</div>
       </div>

       <pickerArea ref="pickerArea" @change="areaConfirm"></pickerArea>
       <chooseMap ref="chooseMap" :lng="Number(formItem.lng)" :lat="Number(formItem.lat)" @sure="mapConfirm"></chooseMap>

       <van-popup v-model="showCategoryPop" position="bottom">
           <van-picker show-toolbar :columns="columns" value-key="categoryName"  @cancel="showCategoryPop = false" @change="onChange" @confirm="onConfirm"  />
       </van-popup>
   </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {getCategory} from "@/api/base"
    import {listConvertTree} from "@/utils/util"
    import {qryShopDetail,saveMallShopInfo} from "@/api/shop"
    import pickerArea from "@/components/picker-area/index"
    import chooseMap from "../chooseAddress"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "baseInfo",
        components:{backTitleBar,pickerArea,chooseMap},
        mixins:[inputFix],
        computed:{
            'areaValue':function(){
                return this.formItem.countyId
            }
        },
        data(){
            return{
                formItem:{
                    areaname:'',
                    imgList:[]
                },
                businessType:'',
                imgList:[],
                popupShow:false,
                showCategoryPop:false,
                columns:[],
                shopId:this.$store.state.user.shopId,
                checked:false,

            }
        },
        created(){
            this.getDetail();

        },
        methods:{
            inputClick(){
                window.setTimeout(function() {
                  document.activeElement.scrollIntoView({block:"center"})
                }, 200);
            },
            areaConfirm(e){
                this.formItem.areaname = e.map(item=>{
                    return item.areaname
                }).join(",")
                this.formItem.provinceId = e[0].areacode;
                this.formItem.cityId = e[1].areacode;
                this.formItem.countyId = e[2].areacode;
            },
            mapConfirm(data){
                this.formItem.lng = data.lng;
                this.formItem.lat = data.lat;
                if(data.address){
                    this.formItem.address = data.address;
                }
            },
            //获取分类
            getCategory () {
                getCategory({businessType: this.businessType}).then(res => {
                    let opt = {
                        primaryKey: 'categoryId',
                        parentKey: 'parentId',
                        startPid: '-1'
                    }
                    let data = listConvertTree(res.data, opt)
                    this.setSelectTree(data)
                })
            },
            setSelectTree (data) {
                let categoryList = data;
                this.columns = [
                    {
                        values: categoryList,  // 设置的页面初始值
                        className: "column1"
                    },
                    {
                        values: categoryList[0].children,
                        className: "column2"
                    },
                ]
            },
            //选中分类
            onConfirm(value){
                if(value[value.length - 1]){
                    this.$set(this.formItem,'businessType',value[value.length -1].categoryId);
                    this.$set(this.formItem,'businessTypeName',value[value.length -1].categoryName);
                }else{
                    this.$set(this.formItem,'businessType',value[value.length -2].categoryId);
                    this.$set(this.formItem,'businessTypeName',value[value.length -2].categoryName);
                }

                this.showCategoryPop = false;
            },
            onChange(picker, values, index) {
                picker.setColumnValues(index + 1, values[index ].children || []); //点当前列更新下一列数据，防止undefined
            },

            //获取商家详情
            getDetail(){
                qryShopDetail(this.shopId).then(res=>{
                    this.formItem = res.data;
                    if(res.data.businessState == 1){
                        this.checked = true;
                    }else{
                        this.checked = false;
                    }
                    if(res.data.shopType == 3){
                        this.businessType = 'offlineShopType'
                    }else if(res.data.shopType == 4){
                        this.businessType = 'onlineShopType'
                    }
                    this.getCategory();
                })
            },

            submitForm(){
                let form = this.formItem
                if(!form.shopName || !form.businessType || !form.serviceTel || !form.linkor || !form.linkTelephone || !form.address || !form.areaname || !form.businessTime){
                    this.$toast("请填写必填项目");
                    return
                }
                let params = {
                    shopName: form.shopName,
                    businessType: form.businessType,
                    businessTypeName:form.businessTypeName,
                    serviceTel: form.serviceTel,
                    linkor: form.linkor,
                    linkTelephone: form.linkTelephone,
                    address: form.address,
                    businessTime: form.businessTime,
                    areaname: form.areaname,
                    provinceId: form.provinceId,
                    cityId: form.cityId,
                    countyId: form.countyId,
                    shopId: form.shopId
                }
                if(this.checked){
                    params.businessState = 1;
                }else{
                    params.businessState = 0;
                }
                saveMallShopInfo(params).then(res=>{
                    if(res.code == 0){
                        this.$toast("保存成功");
                        this.$router.back();
                    }
                })
            },

        }
    }
</script>

<style scoped lang="scss">
    .content{
        padding: .2rem .24rem;
    }
</style>



// WEBPACK FOOTER //
// baseInfo.vue?d344d856